<template>
  <div class="container">
    <v-content size="thinner">
      <div class="page-header">
        <h1>{{ $t('order_finder.title') }}</h1>
      </div>
      <div id="contact-form" class="form">
        <form accept-charset="UTF-8" method="post" @submit.prevent>
          <div class="form__row">
            <label for="order_number">
              {{ $t('order_finder.order_number') }}
            </label>
            <input
              id="order_number"
              v-model="orderNumber"
              type="text"
              name="order_number"
              class="required"
              required
            />
          </div>
          <div class="form__row">
            <label for="email">{{ $t('order_finder.email') }}</label>
            <input
              id="email"
              v-model="email"
              type="email"
              name="email"
              class="required"
              required
            />
          </div>
          <div class="form__submit">
            <v-button full-width @click="searchOrder">
              {{ $t('order_finder.search') }}
            </v-button>
            <div class="authbox__register-link center">
              <p>
                <a
                  href="https://support.shop-gocase.com/hc/en-us/articles/360041056833-How-does-the-delivery-work-"
                  style="color: #ec3faa"
                  target="_blank"
                >
                  {{ $t('order_finder.click_here') }}</a
                >
                {{ $t('order_finder.link_delivery_works') }}
              </p>
              <p>
                {{ $t('order_finder.link_gocase_club') }}
                <a
                  href="https://gocase.com/gosubs/dashboard"
                  style="color: #ec3faa"
                  >{{ $t('order_finder.click_here') }}</a
                >
              </p>
            </div>
          </div>
        </form>
      </div>
    </v-content>
  </div>
</template>

<script>
import VContent from '~/components/shared/v-content/VContent'
import VButton from '~/components/v-button/VButton'
import appendUrlParam from '~/utils/appendUrlParam'

export default {
  components: {
    VContent,
    VButton,
  },
  data() {
    return {
      orderNumber: '',
      email: '',
    }
  },
  mounted() {
    this.orderNumber = this.$route.query.order_number
    this.email = this.$route.query.email
  },
  methods: {
    async searchOrder() {
      if (!this.orderNumber || !this.email) return

      const params = {
        ...this.$store.getters.storeInfo,
        email: this.email,
        number: this.orderNumber,
      }
      try {
        const {
          data: { order },
        } = await this.$apiv2.get(
          appendUrlParam(`orders/find_guest_order`, params)
        )
        await this.$store.dispatch('updateGuestOrder', order)

        if (order) {
          this.$router.push(`/orders/${this.orderNumber}`)
        } else {
          this.$displayTopMessage(this.$t('order_finder.not_found'), {
            type: 'error',
          })
        }
      } catch (err) {
        this.$displayTopMessage(
          err?.response?.data?.message || this.$t('action_error'),
          {
            type: 'error',
          }
        )
      }
    },
  },
  head() {
    return {
      title: this.$t('order_finder.title'),
    }
  },
}
</script>

<style lang="scss">
@import '~/assets/css/form.scss';
</style>
